<template>
	<div class="hris-page">
		<div class="hris-page-inner">
			<div class="hris-page-header">
				<span class="hris-page-eyebrow">Government &amp; Payroll Reports</span>
				<h1 class="hris-page-title">SSS Table</h1>
				<p class="hris-page-subtitle">Manage SSS contribution rate brackets by year.</p>
			</div>

			<div class="hris-toolbar">
				<q-select outlined dense color="green" v-model="yearfilter" :options="yearOptions" label="Year" style="width: 160px;"></q-select>
				<q-btn unelevated class="hris-q-outline" label="Filter" @click="filterData"></q-btn>
				<div class="hris-toolbar-spacer"></div>
				<q-btn v-if="Number(userData.role_id) === 0" unelevated class="hris-q-primary" label="Create" @click="createCutOff"></q-btn>
			</div>

			<div class="hris-panel">
				<q-table
				:dense="$q.screen.lt.md"
				:grid="$q.screen.xs"
				flat
				title="SSS Table"
				:data="generatedData"
				:columns="columns"
				:pagination="initialPagination"
				row-key="id">
				<template v-slot:body="props">
					<q-tr slot="body"  :props="props" @click="selectedRow(props)" style="cursor: pointer;">
						<q-td key="years" :props="props">{{ props.row.years }}</q-td>
						<q-td key="range_from" :props="props">{{ props.row.range_from }}</q-td>
						<q-td key="range_to" :props="props">{{ props.row.range_to }}</q-td>
						<q-td key="employer_contri" :props="props">{{ props.row.employer_contri }}</q-td>
						<q-td key="employee_contri" :props="props">{{ props.row.employee_contri }}</q-td>
						<q-td key="total_contri" :props="props">{{ props.row.total_contri }}</q-td>
					</q-tr>
				</template>
				<template v-slot:no-data="">
					<div class="hris-empty full-width">
						No Result Found!
					</div>
				</template>
				<template v-slot:top-right>
					<q-btn unelevated class="hris-q-outline" label="Download Excel" style="margin-right: 10px;" no-caps @click="exportTable('xlsx')"></q-btn>
					<q-btn unelevated class="hris-q-outline" label="Download CSV" no-caps @click="exportTable('csv')"></q-btn>
				</template>
			</q-table>
			</div>
		</div>

	<q-dialog v-model="spinner" persistent >
		<q-card class="transparent no-shadow">
			<q-card-section >
				<q-spinner-gears color="green"  size="5.5em"></q-spinner-gears>
			</q-card-section>
		</q-card>
	</q-dialog>

	<q-dialog v-model="addDialog" persistent transition-show="scale">
      	<q-card class="hris-modal">
        	<div class="hris-modal-header">
          		<div>
          			<h3 class="hris-modal-title">Create SSS Table</h3>
          			<p class="hris-modal-subtitle">Note: Kindly use "Below" and "Above" in minimum and maximum value</p>
          		</div>
        	</div>
        	<div class="hris-modal-body">
				<q-form @submit="onSubmit" class="q-gutter-md">
                    <q-input outlined dense color="green" v-model="year" label="Year"></q-input>
					<q-input outlined dense color="green" v-model="range_from" label="Range From" lazy-rules :rules="[ val => val && val.length > 0 || 'Required']"></q-input>
					<q-input outlined dense color="green" v-model="range_to" label="Range To" lazy-rules :rules="[ val => val && val.length > 0 || 'Required']"></q-input>
                    <q-input outlined dense color="green" v-model="employer_contri" label="Employer Contribution" lazy-rules :rules="[ val => val && val.length > 0 || 'Required']"></q-input>
                    <q-input outlined dense color="green" v-model="employee_contri" label="Employee Contribution" lazy-rules :rules="[ val => val && val.length > 0 || 'Required']"></q-input>
				  	<div class="hris-modal-footer" style="padding: 0; border-top: none; background: transparent;">
						<q-btn unelevated class="hris-q-ghost" label="Close" type="reset" v-close-popup></q-btn>
						<q-btn unelevated class="hris-q-primary" label="Submit" type="submit"></q-btn>
				  	</div>
					</q-form>
			</div>
      	</q-card>
    </q-dialog>
</div>
</template>

<script>
import axios from 'axios';
import mixins from '../../mixins';
import { exportFile } from 'quasar'
function wrapCsvValue (val, formatFn) {
	let formatted = formatFn !== void 0 ? formatFn(val) : val

	formatted = formatted === void 0 || formatted === null ? '' : String(formatted)

	formatted = formatted.split('"').join('""')
	return `"${formatted}"`
}
export default {
	mixins: [mixins],
	data () {
		return {
			tempID:0,
			initialPagination: {rowsPerPage: 40},
			addDialog: false,
			yearfilter:new Date().getFullYear(),

			year:new Date().getFullYear(),
            range_from:'',
			range_to:'',
			employer_contri:'',
			employee_contri:'',

			yearOptions: [],

			separator:'cell',
			spinner:false,
			generatedData:[],

			columns: [
            { name: 'years', align: 'center', label: 'Years', field: 'years', sortable: true},
			{ name: 'range_from', align: 'center', label: 'Range From', field: 'range_from', sortable: true},
			{ name: 'range_to', align: 'center', label: 'Range To', field: 'range_to', sortable: true},
			{ name: 'employer_contri', align: 'center', label: 'Employer\'s Contribution', field: 'employer_contri' , sortable: true},
			{ name: 'employee_contri', align: 'center', label: 'Employees Contribution', field: 'employee_contri' , sortable: true},
			{ name: 'total_contri', align: 'center', label: 'Total Contribution', field: 'total_contri' , sortable: true},
			],

		}
	},

	created(){
		this.filterData()
		this.yearsList()
	},

	methods: {
		onSubmit () {
			let formData = new FormData();
			formData.append("tempID", this.tempID);
            formData.append("year", this.year);
			formData.append("range_from", this.range_from);
			formData.append("range_to", this.range_to);
			formData.append("employer_contri", this.employer_contri);
			formData.append("employee_contri", this.employee_contri);

			axios.create({
				baseURL : this.apiUrl,
				headers : {'Authorization' : `Bearer ${this.token}`}
			}).post('/backend/sss/set',formData)
			.then((res) => {
				this.tempID = 0
				this.onReset()
				this.filterData()
				this.$q.notify({
		          color: 'green-9',
		          textColor: 'white',
		          message: 'Submitted'
		        })
				this.addDialog = false
			});

    	},

		onReset () {

            this.range_from = ''
			this.range_to = ''
            this.employer_contri = ''
			this.employee_contri = ''
			this.tempID = 0
	    },

		createCutOff: function(){
            this.onReset()
			this.addDialog = true
		},

		selectedRow:function(obj){
			if (Number(this.userData.role_id) !== 0) return
            this.tempID = obj.row.id
            this.year = obj.row.years
			this.range_from = obj.row.range_from
			this.range_to = obj.row.range_to
            this.employer_contri = obj.row.employer_contri
			this.employee_contri = obj.row.employee_contri
			this.addDialog = true
		},

		filterData : function(){
			this.spinner = true;
			let formData = new FormData();
			formData.append("year", this.yearfilter);
			axios.create({
				baseURL : this.apiUrl,
				headers : {'Authorization' : `Bearer ${this.token}`}
			}).post(`/backend/sss/table`,formData)
			.then((res) => {
				//console.log(res.data)
				this.generatedData = res.data.data
				this.spinner = false
			});
		},

		yearsList : function(){
			axios.create({
				baseURL : this.apiUrl,
				headers : {'Authorization' : `Bearer ${this.token}`}
			}).post(`/timekeeping/years/list`)
			.then((res) => {
				this.yearOptions = res.data.data
			});
		},

		exportTable:function(fileExtension){

			const content = [ this.columns.map(col => wrapCsvValue(col.label)) ].concat(
			this.generatedData.map(row => this.columns.map(col => wrapCsvValue(
			typeof col.field === 'function'
			? col.field(row)
			: row[col.field === void 0 ? col.name : col.field],
			col.format
			)).join(','))
			).join('\r\n')

			const status =  exportFile(
				`SSSTable.${fileExtension}`,
				content,
				`text/${fileExtension}`
			);

			if (status !== true) {
				this.$q.notify({
					message: 'Browser denied file download...',
					color: 'negative',
					icon: 'warning'
				})
			}
		},
	}
}
</script>
<style lang="css" scoped>
.center{
	text-align:center
}
</style>
<style lang="sass" scoped>
	.my-sticky-column-table
		thead tr:nth-child(2) th:nth-child(2)
			background-color: #fff
		td:nth-child(2)
			background-color: #c1f4cd
		th:nth-child(2)
		td:nth-child(2)
			position: sticky
			left: 0
			z-index: 1
</style>
